import {supportNative, getErrorFactory, logError} from './util';
import Detector from '../utils/detector';

const zzc = window.zzc;

/**
 * 调用原生播放视频或者显示图片幻灯片
 * 注意图片的url必须要带有http头
 * @param {*} media  资源列表
 * @param {*} showIndex 当前要显示的索引
 */
export default function MediaViewer(options) {
  let errorFactory = getErrorFactory('base_mediaViewer');

  if (!supportNative('base_mediaViewer')) {
    return logError(errorFactory('不支持zzcjsbridge'));
  }

  zzc.call('base_mediaViewer', options);
  
  
}



// WEBPACK FOOTER //
// ./src/native/MediaViewer.js